import cAppeared from './components/c-appeared';
import preloader from './components/c-preloader';
import pageError from './components/c-page-error';
import headerAppearance from './components/c-header-appearance';
import cDetails from './components/c-details';
import switchFocus from './utils/switchFocus';

cAppeared();
cDetails();
preloader();
pageError();
headerAppearance();
switchFocus();

document.addEventListener('DOMContentLoaded', async () => {
  const cOutlineModule = await import('./components/c-outline');
  const cOutline = cOutlineModule.default;

  cOutline();
});

window.addEventListener('load', async () => {
  const barbaModule = await import('./blocks/barba');
  const lazyVideosModule = await import('./utils/lazyVideos');
  const barba = barbaModule.default;
  const lazyVideos = lazyVideosModule.default;

  barba();
  lazyVideos();
});

document.addEventListener('preloaderDone', async () => {
  sessionStorage.setItem('preloaderDone', 'true');

  const headerVerticalScrollModule = await import('./components/c-header-vertical-scroll');
  const headerVerticalScroll = headerVerticalScrollModule.default;

  headerVerticalScroll();
});
